var PES = PES || {};
PES.CopyAndPasteAnimationType = {};
PES.CopyAndPasteAnimationType.Open = 1;
PES.CopyAndPasteAnimationType.Close = 2;
PES.ExcelAnimation= function() {
    var _canRunCloseAnimation = false;
    var _canRunOpenAnimation = true;
    var runOpenSlideAnimation= function() {
        $(".cp-wizard-image").animate({
            left: "657px"
        }, {
            duration: 2000,
            queue: false,
            start: function (animation, junpedToEnd) {
                _canRunOpenAnimation = false;
                $(".cp-colored-gradient").fadeOut();
            },
            fail: function (animation, junpedToEnd) {
                $(".cp-colored-gradient").fadeOut();
            },
            done: function () {
                _canRunCloseAnimation = true;

                $(".cp-excel-menu").animate({
                    opacity: 1
                }, {
                    duration: 1000,
                    queue: false
                });

                $(".cp-wizard-menu").animate({
                    opacity: 1
                }, {
                    duration: 1000,
                    queue: false
                });
            }
            });

        $(".cp-excel-image").animate({
            left: "-60px"
        }, {
            duration: 2000,
            queue: false
        });

        $(".cp-gray-gradient").animate({
            opacity: 1
        }, {
            duration: 2000
        });
    }

    var runCloseSlideAnimation = function() {
        $(".cp-wizard-image").animate({
            left: "0px"
        }, {
            duration: 2000,
            queue: false,
            start: function () {
                $(".cp-excel-menu").animate({
                    opacity: 0
                }, {
                    duration: 1000,
                    queue: false
                });

                $(".cp-wizard-menu").animate({
                    opacity: 0
                }, {
                    duration: 1000,
                    queue: false
                });
            },
            done: function (animation, junpedToEnd) {
                $(".cp-colored-gradient").fadeIn();
                _canRunCloseAnimation = false;
                _canRunOpenAnimation = true;
            },
            fail: function (animation, junpedToEnd) {
                $(".cp-colored-gradient").fadeIn();
            }
        });

        $(".cp-excel-image").animate({
            left: "355px"
        }, {
            duration: 2000,
            queue: false
        });

        $(".cp-gray-gradient").animate({
            opacity: 0
        }, { duration: 1500 });
    }

    var runSildeAnimation = function (animationType) {
        if (animationType === PES.CopyAndPasteAnimationType.Open) {
            runOpenSlideAnimation();
        } else {
            runCloseSlideAnimation();
        }
    }

    var bindEvents = function () {
        var parentContainerId = $(".cp-images-container").parent().attr("id");
        //run animation when the Copy&Paste tab is clicked
        $('a[href="#' + parentContainerId + '"]').on("click", function () {
            if (_canRunOpenAnimation) {
                runSildeAnimation(PES.CopyAndPasteAnimationType.Open);
            }
        });

        $(".cp-images-container").on("mouseenter click tap", function () {
            if (_canRunOpenAnimation) {
                runSildeAnimation(PES.CopyAndPasteAnimationType.Open);

            }
        }).on("click", function () {
            if (_canRunCloseAnimation) {
                runSildeAnimation(PES.CopyAndPasteAnimationType.Close);
            }
        });
    };

    var initCopyPasteAnimation = function () {
        bindEvents();
    }
    return {
        initCopyPasteAnimation: initCopyPasteAnimation
    }
}